import {Injectable} from '@angular/core';
import {Shipment} from '../domain/shipment';
import {Parcel} from '../domain/parcel';
import {RequestExecutor} from '../util/request-executor';
import {Session} from '../domain/session';
import {Deviation} from '../domain/deviation';

@Injectable()
export class TrackService {
  constructor(private request: RequestExecutor, private session: Session) {
  }

  async getShipment(query: string): Promise<Shipment> {
    const path = this.session.isValid() ? '/shipment' : '/shipment/public';

    try {
      const shipment = await this.request.get(path, {query: query})

      this.resolveStatus(shipment);

      shipment.AttachmentIds = [];

      shipment.Deviations.forEach((deviation: Deviation) => {
        shipment.AttachmentIds.push(...deviation.AttachmentIds);
      });

      shipment.Parcels.forEach((parcel: Parcel) => {
        parcel.Events.sort((a, b) => new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime());
        parcel.AttachmentIds = [];

        parcel.Deviations.forEach((deviation: Deviation) => {
          parcel.AttachmentIds.push(...deviation.AttachmentIds);
        });
      });

      return shipment;
    } catch (error) {
      if (error.status === 404) {
        error.error = {
          errorMessage: 'Sendingen finnes ikke',
          icon: 'error_outline',
          css_class: 'warn'
        };
      }
      return error;
    }
  }

  resolveStatus(shipment: Shipment) {
    let pickedUp = 0;
    let delivered = 0;

    shipment.Parcels.forEach((parcel: Parcel) => {
      if (parcel.Events.length !== 0) {
        parcel.Events.sort((a, b) => new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime());

        switch (parcel.Events[0].Type) {
          case 'PickUp':
            pickedUp++;
            break;
          case 'Deliver':
            delivered++;
            break;
        }
      }
    });

    if (shipment.Parcels.length === delivered) {
      shipment.OrderStatus = 'Finished';
    } else if (pickedUp > 0 || delivered > 0) {
      shipment.OrderStatus = 'Started';
    } else {
      shipment.OrderStatus = 'Registered';
    }
  }
}
